﻿import {Message} from "@2d-front-monorepo/design-library";
import {Attachments, ICreateComponentAttachments} from "@2d-front-monorepo/permits-business";

import {JSX, useCallback, useMemo} from "react";
import {useParams} from "react-router";
import UpdateAttachmentsComponent from "../../components/UpdateAttachmentsComponent";
import {ReloadEntities, reloadPermits} from "../../hooks/reloadPermits";
import {usePermits} from "../../hooks/usePermits";

export default function DocumentUpdate(): JSX.Element {
	const {documentId} = useParams();
	const permitsState = usePermits();
	const documents = useMemo(() => Attachments.list(permitsState), [permitsState]);
	const document = documents.find(x => x.attachment.id === documentId);
	const initialState = useMemo<ICreateComponentAttachments>(() => ({
		attachments: {}
	}), []);

	const onSubmit = useCallback(async function (): Promise<void> {
		let reload: ReloadEntities;

		switch (document?.entityType) {
			case "permit":
				reload = ReloadEntities.Permits;
				break;

			case "reservation":
				reload = ReloadEntities.Reservations;
				break;

			// case "vehicle":
			// case "driver":
			// case "residency":
			// case "holder":
			default:
				reload = ReloadEntities.Holder;
				break;
		}

		await reloadPermits(reload);
		window.history.back();
		// navigate(PrivateRoutes.documents);
	}, [document?.entityType]);

	if (document == null) {
		return <Message title={{text: `Invalid document id: [${documentId}]`}} type="error"/>;
	}

	return <UpdateAttachmentsComponent attachments={[document.attachment]} onSubmit={onSubmit}
	                                   initialState={initialState}/>;
}
